import { render, staticRenderFns } from "./DeviceCompoent.vue?vue&type=template&id=63d683bb&"
import script from "./DeviceCompoent.vue?vue&type=script&lang=ts&"
export * from "./DeviceCompoent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports